import { msg } from "@lit/localize";
import { createAsyncActionGroup } from "@progressive-development/pd-spa-helper";

import type { ParteiSichtErgebnis } from "../service/parteien-service.js";

/** Die Sicht einer Partei — Nutzlast ist der Slug aus der Adresse. */
export const loadParteiSicht = createAsyncActionGroup<string, ParteiSichtErgebnis>(
  "LOAD_PARTEI_SICHT",
  {
    loadingTxt: msg("Partei wird geladen…", { id: "app.partei.loading.toast" }),
    smallBackground: true,
  },
);
